<template>
  <div class="actions-wrapper">
    <template v-if="layoutMode === 'side' || (layoutMode === 'top' && isDesktop)">
      <span
        @click="handleClick({key: 'modifyPassword'})"
        class="action"
        title="修改密码"
        style="font-size: 22px;"
      >
        <!-- <a-icon type="logout" /> -->
        <a-icon type="user" />
      </span>
      <span
        @click="handleClick({key: 'logout'})"
        class="action"
        title="退出登录"
        style="font-size: 22px;"
      >
        <a-icon type="poweroff" />
      </span>
      <span class="action avatar">
        <!-- <a-avatar
          size="small"
          :style="`background-color:${defaultColor};color: #fff;`"
        >{{ username.slice(0,1) }}</a-avatar> -->
      </span>
      <!-- <span class="action welcome">欢迎您，{{username}}</span> -->
    </template>
    <template v-else>
      <a-dropdown :trigger="['click']">
        <a-avatar
          icon="ellipsis"
          size="small"
          class="actions-trigger"
          :style="`background: ${defaultColor}`"
        ></a-avatar>
        <a-menu slot="overlay" @click="handleClick" class="user-menu">
          <a-menu-item class="user">
            <!-- <a-avatar
              size="small"
              :style="`background-color:${defaultColor};color: #fff;`"
            >{{ username.slice(0,1) }}
            </a-avatar> -->
            <!-- 欢迎您，{{username}} -->
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="modifyPassword">
            <a href="javascript:;">
              <a-icon type="logout" style="margin-right: 5px; vertical-align: middle;" />
              <span style="vertical-align: middle;">修改密码</span>
            </a>
          </a-menu-item>
          <a-menu-item key="logout">
            <a href="javascript:;">
              <a-icon type="poweroff" style="margin-right: 5px; vertical-align: middle;" />
              <span style="vertical-align: middle;">退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </template>
    <modify-password :visible="modalVisible" @close="modalVisible = false"></modify-password>

    <!-- 安全提示 -->
    <a-modal 
    v-model="tipsVisible"
    width="420px"
    :footer="null" 
    :closable="false" 
    :maskClosable="false">
      <h2 class="title">安全提示</h2>
      <p class="tips">您的密码已经超过90天未修改，请您立即更改密码。</p>
      <a-button class="btn" type="link" size="large" @click="editPassword">立即修改</a-button>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { appStoreMixin, deviceMixin } from '@/mixins'
import ModifyPassword from '@/components/ModifyPassword'

export default {
  components: { ModifyPassword },
  mixins: [appStoreMixin, deviceMixin],
  data () {
    return {
      tipsVisible: false,
      modalVisible: false
    }
  },
  computed: {
    ...mapGetters('user', ['username'])
  },
  created () {
    this.getPassTime()
  },
  methods: {
    ...mapActions('user', ['Logout']),
    handleClick ({ key }) {
      const self = this
      if (key === 'modifyPassword') {
        // 注释掉框架自带的修改密码组件
        // this.modalVisible = true
        this.$store.commit('app/SET_ROUTEURL', './auth/#/authority/password')
      } else if (key === 'logout') {
        this.$confirm({
          title: '退出',
          content: `确定要退出当前登录吗？`,
          okText: '退出',
          okType: 'danger',
          onOk () {
            self.Logout().then(() => {
            })
            sessionStorage.clear()
            self.$router.replace('/login')
          },
          onCancel () {
            self.$message.warning('取消操作')
          }
        })
      }
    },

    getPassTime () {
      const infoStr = sessionStorage.getItem('loginInfo')
      const info = infoStr ? JSON.parse(infoStr) : {}
      const date = info.pwdUpdateTime
      const startDate = new Date(date)
      const currentDate = new Date()
      const usedDate = currentDate - startDate
      const day = Math.floor(usedDate / (24 * 3600 * 1000))
      console.log('\n\n\n---day---', day)
      if (day >= 90) {
        this.tipsVisible = true
      }
    },

    editPassword () {
      this.tipsVisible = false
      this.modalVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .actions-wrapper {
    overflow: hidden;

    .actions-trigger {
      transform: rotate(90deg);
      cursor: pointer;
      color: #fff;
    }

    .action {
      display: inline-block;
      height: 100%;
      padding: 0 12px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .avatar,
    .welcome {
      cursor: default;
      user-select: none;

      &:hover {
        background: none;
      }
    }
  }

  .ant-modal .ant-modal-body .title {
    width: 100%;
    text-align: center;
    margin-bottom: 32px;
  }

  .ant-modal .ant-modal-body .tips {
    width: 100%;
    font-size: 18px;
    margin-bottom: 20px;
    color: #888;
  }

  .ant-modal .ant-modal-body .btn {
    width: 100%;
    font-size: 20px;
  }
</style>
